import React from "react";
import { Link } from "react-router-dom";

const articles = [
    {
        path: "/how-matching-works",
        title: "How Matching Works",
        summary: "Understand how the CareerMission algorithm scores candidates against your superstar target."
    },
    {
        path: "/how-to-pick-great-targets",
        title: "How to Pick Great Targets",
        summary: "Choose the right superstar target for accurate candidate matching."
    }
];

const BlogIndex = () => {
    return (
        <div className="min-h-screen bg-darkblue text-lightgray px-6 py-16">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-4xl text-orange text-center mb-8">
                    Guides & Resources
                </h1>

                <div className="grid gap-6 md:grid-cols-2">
                    {articles.map((article) => (
                        <Link
                            key={article.path}
                            to={article.path}
                            className="block bg-bluegray rounded-lg p-6 hover:border hover:border-orange transition-colors"
                        >
                            <h2 className="text-xl font-semibold text-orange mb-2">
                                {article.title}
                            </h2>
                            <p className="text-gray-300">{article.summary}</p>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BlogIndex;
